import { Component, OnInit } from '@angular/core';
import { EmailConfigured, StatusCode } from '@shared/_enums/Common';
import { CommonService } from '@services/app.common.service';
import { ClienDivisionsSecurityDTO } from '@shared/_models/settings/settingsModels';
import { RoleAccessService } from '@services/role.access.service';
import { PwnedPasswordService } from '@shared/_services/pwned-password.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { User } from '../Interface/force-password-change.interface';

@Component({
  selector: 'app-change-compromised-password',
  templateUrl: './changeCompromisedPassword.component.html',
  standalone: false
})
export class ChangeCompromisedPasswordComponent implements OnInit {
  StatusCode = StatusCode;
  user = {} as User;
  paswordComplexity = {} as ClienDivisionsSecurityDTO;
  PasswordInstruntion = '';
  appValForm!: FormGroup;
  submittedForm: boolean = false;
  isPasswordBreached: boolean = false;
  constructor(
    public common: CommonService,
    public roleService: RoleAccessService,
    public pwnedPasswordService: PwnedPasswordService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.populateData();
  }

  get controls() {
    return this.appValForm.controls;
  }
  private initForm(): void {
    this.appValForm = this.fb.group(
      {
        id: [0],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        userName: ['', Validators.required],
        emailAddress: ['', [Validators.required, Validators.email]],
        oldPassword: ['', Validators.required],
        password: [
          '',
          [Validators.required, this.passwordComplexityValidator.bind(this)]
        ],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.pwnedPasswordService.passwordMatchValidator }
    );
  }

  private populateData(): void {
    this.common.GetData(this.common.ApiUrls.SystemUser.GetCurrentUserDetail, true).then((data) => {
        this.user = data.resultData.currentUser;
        this.paswordComplexity = data.resultData.passwordComplexity;
        this.appValForm.patchValue(this.user);
      });
  }

  private passwordComplexityValidator(control: AbstractControl): ValidationErrors | null {
    return this.pwnedPasswordService.passwordComplexityValidator(control, this.paswordComplexity);
  }

  public async Save(): Promise<void> {
    this.appValForm.markAllAsTouched();
    this.submittedForm = true;
    if (this.appValForm.invalid) {
      return;
    }

    const password = this.controls.password.value;

    this.isPasswordBreached = await this.pwnedPasswordService.isPasswordBreached(password);
    if (this.isPasswordBreached) {
      return;
    }
    else {
      const payload = {
        ...this.user,
        ...this.appValForm.value,
        isOnlyPasswordUpdate: false,
        option: 'SigninDetails',
      };

      this.common.PostData(this.common.ApiUrls.SystemUser.UpdatePersonalSetting, payload, true).then((data) => {
        switch (data.status) {
          case StatusCode.OK:
            this.controls.password.reset();
            this.controls.confirmPassword.reset();
            this.common.message = '';
            this.common.RemoveLocalStorage('jt_password_compromised');
            this.common.Notification.success(
              this.common.GetTranslation('Messages.Updated')
            );
            this.common.NavigateToRoute('Login');
            break;

          case StatusCode.Restricted:
            if (data.resultData === 0) {
              this.common.Notification.info(this.common.GetTranslation('Messages.passwordMatch'));
            }
            else {
              this.common.Notification.info(this.common.GetTranslation('Messages.OldPasswordNotMatch'));
            }
            break;
         
          default:
            this.common.Notification.error(
              this.common.GetTranslation('Messages.SomeThingWentWrong')
            );
        }
      });
    }

    
  }

  public strengthChanged(): void {
    this.common.GetPasswordStrengthInfo(
      this.controls.password.value,
      this.paswordComplexity
    );
  }

  public SignOut(): void {
    this.common.logOut();
  }

}

